module.exports = __webpack_public_path__ + "img/pending.60a87eea.svg";